var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56251 3.00238L7.99997 3.79277L8.43744 3.00238C8.73568 2.46353 9.17083 2.01291 9.69895 1.69604C10.2229 1.3817 10.8198 1.21002 11.4305 1.19795C12.415 1.24461 13.3417 1.67696 14.01 2.40182C14.6817 3.1303 15.0377 4.095 15.0003 5.08515L15 5.09457V5.104C15 6.3604 14.3318 7.73804 13.2929 9.1027C12.263 10.4555 10.919 11.7305 9.67864 12.7709L9.6783 12.7712C9.20825 13.1662 8.61395 13.3828 7.99997 13.3828C7.386 13.3828 6.79169 13.1662 6.32165 12.7712L6.3213 12.7709C5.08094 11.7305 3.73692 10.4555 2.70703 9.1027C1.66813 7.73804 0.999974 6.3604 0.999974 5.104V5.09457L0.999618 5.08515C0.962256 4.095 1.31829 3.1303 1.98994 2.40182C2.65825 1.67696 3.58498 1.24461 4.56941 1.19795C5.1801 1.21002 5.77709 1.3817 6.301 1.69604C6.82911 2.01291 7.26427 2.46353 7.56251 3.00238Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.c5eb53039373e3c7c2a88d8c5a0e24cf.svg";
export { ForwardRef as ReactComponent };